// components/ArticleList.tsx
import React, { } from 'react';
import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Texto from '../../Texto';
import { textosPeque } from '@/constants/Dimens';
import { UsuarioLogrosObj } from '@/objects/Gamificacion';
import ImageRound from '../../ImageRound';
import { comprobarAvatar } from '@/util/Articulos';
import { black, lightGray, oro, primary, white } from '@/constants/Colors';

interface Props {
  usuarioLogrosObj: UsuarioLogrosObj;
  posicion: number;
}

const RowRanking: React.FC<Props> = ({ usuarioLogrosObj, posicion }) => {
  const { t } = useTranslation();

  const topColor = posicion === 0 ? oro : posicion === 1 ? '#9AA4B2' : posicion === 2 ? '#A46A4D' : primary;
  const nombreUsuario = usuarioLogrosObj.nombre || 'Usuario';

  const abrirPerfilUsuario = () => {
    window.location.href = "/individuales/" + usuarioLogrosObj.id_user;
  }

  return (
    <Card
      onClick={abrirPerfilUsuario}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'min(520px, 94%)',
        padding: '14px 18px',
        marginTop: '14px',
        borderRadius: '16px',
        border: `1px solid ${posicion < 3 ? topColor : '#E9E4DF'}`,
        boxShadow: posicion < 3 ? '0 10px 24px rgba(0,0,0,0.12)' : '0 5px 14px rgba(0,0,0,0.08)',
        background: posicion < 3 ? `linear-gradient(135deg, ${white} 0%, #FAF7F2 100%)` : white,
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
        <section style={{ width: '42px', height: '42px', borderRadius: '50%', backgroundColor: topColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Texto color={white} fontWeight={'700'}>#{posicion + 1}</Texto>
        </section>

        <section style={{ marginLeft: '12px', marginRight: '12px' }}>
          <ImageRound
            alt={'avatar_' + nombreUsuario}
            src={comprobarAvatar(usuarioLogrosObj.imagen || '')}
            width={48}
            height={48}
            style={{ border: `2px solid ${posicion < 3 ? topColor : '#DDD'}` }}
          />
        </section>

        <section style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
          <Texto color={black} fontWeight={'700'} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {nombreUsuario}
          </Texto>
        </section>

        <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Texto color={black} fontWeight={'700'}>{usuarioLogrosObj.logros}</Texto>
          <Texto color={lightGray} fontSize={textosPeque}>{t('menu:secciones.ranking.logros')}</Texto>
        </section>
      </article>
    </Card>
  );
};

export default RowRanking;
